import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

const PayOnlineView = () => import('../views/PayOnline.vue');
const AcceptQuoteView = () => import('../views/AcceptQuote.vue');

Vue.use(VueRouter);

let routes: Array<RouteConfig> = [
	{
		path: '/legacy-payment-link-nz',
		redirect: (to) => {
			const { query } = to;
			const newQuery = {
				customer: String(query.b_company),
				first_name: String(query.b_fname),
				last_name: String(query.b_lname),
				email: String(query.email),
				invoiceNumber: String(query.reference_number),
				type: 'quote',
				amount: query.initial_amount,
				env: 'NZ',
			};
			return { path: '/', query: newQuery };
		},
	},
	{
		path: '/accept-quote',
		name: 'AcceptQuote',
		component: AcceptQuoteView,
	},
	{
		path: '/',
		name: 'PayOnline',
		component: PayOnlineView,
	},
	{
		path: '/*',
		redirect: '/',
	},
];

const router = new VueRouter({
	mode: 'history',
	base: '/',
	routes,
});

export default router;
